import { useRef, useEffect } from "react";
import {
  setIntersectionObserver,
  unsetIntersectionObserver,
} from "../utils/setIntersectionObserver";
import { fireProductComponentImpression } from "../utils/marketingTracking/marketingTrackingEvents";

export const IMPRESSION_DWELL_MS = 500;

export default function useProductComponentImpression({
  products,
  itemListName,
  threshold = 1.0,
}) {
  const elementRef = useRef(null);

  useEffect(() => {
    const elementNode = elementRef.current;
    let observer = null;
    let dwellTimer = null;

    if (elementNode && products?.length > 0) {
      observer = setIntersectionObserver({
        element: elementNode,
        debounceMs: 0,
        options: { threshold },
        handleIntersectionData: (entry, helpers) => {
          if (entry.isIntersecting) {
            clearTimeout(dwellTimer);
            dwellTimer = setTimeout(() => {
              dwellTimer = null;
              fireProductComponentImpression({ products, itemListName });
              helpers.unobserve(elementNode);
            }, IMPRESSION_DWELL_MS);
          } else if (dwellTimer) {
            clearTimeout(dwellTimer);
            dwellTimer = null;
          }
        },
      });
    }

    return () => {
      if (dwellTimer) {
        clearTimeout(dwellTimer);
      }
      unsetIntersectionObserver(elementNode, observer);
    };
  }, [products, itemListName, threshold]);

  return {
    ref: elementRef,
    firstItemRef: (index) => (index === 0 ? elementRef : null),
  };
}
